<template>
  <div @click="handleSelectProduct(product)" class="my-2 lg:my-0 cursor-pointer transition duration-250 relative p-8 bg-white rounded-2xl shadow-sm flex flex-col border border-solid font-gotham-medium" :class="[isSelectedProduct ? 'border-black' : 'border-gray-200']">
    <div class="flex-1">
      <h3 class="text-xl font-semibold text-gray-900">Talk {{ utilityService.toTitleCase(product.name) }}</h3>
      <p class="mt-0 lg:mt-4 flex items-baseline text-gray-900">
        <span class="text-5xl font-extrabold tracking-tight">${{ product.price }}</span>
        <span class="ml-1 text-xl font-semibold text-gray-900">/Month</span>
      </p>

      <!-- Feature list -->
      <ul role="list" class="mt-0 lg:mt-4 mb-2 space-y-6">
        <li class="flex">
          <span class="text-gray-500">{{ product.description }}</span>
        </li>
      </ul>

      <a v-for="standardLink in standardLinks" :key="standardLink.name" :href="standardLink.link" target="_blank" class="block href text-blue-500 hover:text-blue-800 hover:underline transition duration-250 my-3">
        {{ standardLink.name }}
      </a>
    </div>
    <button :class="[('mt-0 lg:mt-3 block w-full py-3 px-6 border border-transparent rounded-md text-center font-gotham-medium '), (isSelectedProduct ? 'bg-brand-primary text-white' : 'bg-brand-primary-light hover:bg-brand-primary text-brand-secondary')]">{{ isSelectedProduct ? 'Selected' : 'Select Product'}}</button>
  </div>
</template>

<script setup lang='ts'>
import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '../../services/utilityServiceInterface';
import { defineProps, defineEmits } from 'vue';
import { BrandServiceInterface } from '../../services/brand/brandServiceInterface';

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}

defineProps<{
  isSelectedProduct: boolean
  product: Product
}>();

const emit = defineEmits<{(event: 'handle-select-product', product: Product): void}>();

const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};

const standardLinks: Array<{ name: string, link: string }> = [{
  name: 'Critical Information Summary',
  link: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${brandService.getName()}/critical-information-summary-phone.pdf`
}];
</script>
